import { PageName } from './core/enums/PageName';
import { QueueService } from 'src/app/queue/queue/queue.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WebLinkTokenResponse } from 'src/app/core/models/WebLinkTokenResponse';
import { StoreService } from 'src/app/store/store/store.service';
import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateCacheService } from 'ngx-translate-cache';
import { ChannelService } from './home/channel/channel.service';
import { CXMCustomerAddressResponse } from './core/models/CXMCustomerAddressResponse';
import { UserService } from './core/user/user.service';
import { NavigationEnd, Router } from '@angular/router';
import { StoreMode } from './core/enums';
import { Subscription } from 'rxjs';
import { LoaderService } from './core/loader-services/loader.service';
import { PopupAddressFormService } from './core/services/popup-address-form.service';
import { CommonAddressResponse } from './core/models/CommonAddressResponse';
import { QrCartStore } from './core/qr-cart/qr-cart.store';
import { QrCartService } from './core/qr-cart/qr-cart.service';
import { ToastData } from './core/models/ToastData';
import { ToastService } from './shared/services/toast.service';
import { ChannelSecService } from './home/channelsec/channelsec.service';
import { CartService } from './core/cart/cart.service';
import { PlatformSet } from './core/models';
import { ChannelQuery } from './home/channel/channel.query';
import { OrderTypeFlag } from './core/enums/OrderTypeFlag';
import { StaticQrService } from './core/static-qr/static-qr.service';
import { QrScannerService } from './core/services/qr-scanner.service';
import { SetCode } from './core/enums/SetCode';
import { TimeService } from './core/services/time.service';
import * as moment from 'moment';
import { GuestOrderService } from './shared/services/guest-order.service';
import { RoutingService } from './home/services/routing.service';
import { UserQuery } from 'src/app/core/user/user.query';
import { AnalyticsService } from './shared/services/analytics.service';
import { StorageService } from './shared/services/storage.service';
import { SessionStorageService } from './shared/storage/session-storage.service';
import { SeoService } from 'src/app/shared/services/seo.service';
import { DOCUMENT, PlatformLocation } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { QrCartQuery } from './core/qr-cart/qr-cart.query';
import { WeblinkService } from 'src/app/shared/services/weblink.service';
import { RewardService } from 'src/app/account/services/reward.service';
import { PopupMessageService } from './core/services/popup-message.service';
import { AddressService } from './shared/services/address.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  displayAddressDialog: boolean = false;
  displayOrderTypeAdressDialog: boolean = false;

  displayAddress = false;
  displayAddAddress = false;
  savedAddress: CXMCustomerAddressResponse[] = [];
  editUserAddress: CXMCustomerAddressResponse;
  updateAddressSuccess: boolean = false;
  isUserLogin: boolean = false;
  sub: Subscription = new Subscription();
  channelSub: Subscription = new Subscription();
  loadingSubscription: Subscription;
  isFinishedLoading: boolean = false;
  curRouter: string = '';
  showMobileHeader: boolean = false;
  showMobileBottomNav: boolean = false;
  localSavedNewAddress: CommonAddressResponse;
  qrTokenResponse: WebLinkTokenResponse;
  displayQuitQrDineMessage: boolean;
  quitQrDineInSub: Subscription;
  isLogOut: boolean;
  logOutSub: Subscription;
  qrDialog: Subscription;
  quitQueueSub$: Subscription;

  //dialog
  isMobileView: boolean;
  channelSetting: PlatformSet[] = [];
  shareTable: boolean = false;
  channelOrderType: string = '';
  orderTypeFlag = OrderTypeFlag;
  displayScanner: boolean = false;
  qrScannerData: any;

  displayQrPopup: boolean = false;
  barCodeValue: any;
  qrCodeValue: any;
  private qrPopupOverview: { barCodeValue: any; qrCodeValue: any } | null = null;
  qrScannerSub$: Subscription;
  fulladdress: string;
  channelId: number;

  qrQuerySub$: Subscription;
  isShowQrExpired: boolean = true;
  isDisplayQRExpired: boolean = true;
  expiryTime: string = '';
  serverTime: string = '';
  submitingOrder: boolean = false;
  submittingSub$: Subscription;
  isRotate: boolean = false;
  displayEnablePermissionDialog: boolean = false;
  private enablePermissionDialogSub: Subscription;

  constructor(
    private guestOrderService: GuestOrderService,
    public translate: TranslateService,
    public translateCacheService: TranslateCacheService,
    private channelService: ChannelService,
    private userService: UserService,
    private router: Router,
    private loadingScreenService: LoaderService,
    private storeService: StoreService,
    private popupAddressFormService: PopupAddressFormService,
    private qrCartStore: QrCartStore,
    private qrCartService: QrCartService,
    private toastService: ToastService,
    private channelSecService: ChannelSecService,
    private cartService: CartService,
    private channelQuery: ChannelQuery,
    private staticQrService: StaticQrService,
    private qrScannerService: QrScannerService,
    private routingService: RoutingService,
    private timeService: TimeService,
    private queueService: QueueService,
    private userQuery: UserQuery,
    private analyticsService: AnalyticsService,
    private storageService: StorageService,
    private sessionStorageService: SessionStorageService,
    private seoService: SeoService,
    private platformLocation: PlatformLocation,
    @Inject(DOCUMENT) private document: any,
    private addressService: AddressService,
    private themeService: ThemeService,
    private qrCartQuery: QrCartQuery,
    private weblinkService: WeblinkService,
    private rewardService: RewardService,
    private popupMessageService: PopupMessageService
  ) {

    translate.setDefaultLang('en');

    // The order of precedence
    // 1. Cached language.
    // 2. Current language of the browser.
    // 3. Default language (language used as a fallback for *ngx-translate*).
    translateCacheService.init();

    //updating seo
    this.updateMetaTag(this.document.location.href);

    this.router.events.subscribe(async event => {
      if (event instanceof NavigationEnd) {

        let membershipError = localStorage.getItem('membershipError');
        if (membershipError) {
          let descError = membershipError ?? 'error.occus.to.getting.membership'
          this.popupMessageService.show({
            icon: "icon-alert",
            title: "something.went.wrong",
            desc: descError,
            btn: "button.retry",
          });
          localStorage.removeItem('membershipError')
        }

        // let currentUrlPath1 = event.url.split("/")[1];
        let currentUrlPath1 = event.url;
        const current = event.urlAfterRedirects;

        if (event.url && currentUrlPath1) {
          let currentUrl = event.url;

          if (!currentUrl.includes('/login') && !currentUrl.includes('/password-login') && !currentUrl.includes('/otp')
            && !currentUrl.includes('/forgot-password') && !currentUrl.includes('/account-detected') && !currentUrl.includes('/cart')) {
            this.sessionStorageService.removeItem("isPayment");
            this.sessionStorageService.removeItem("isConfirmOrder");
          }

          if (currentUrl.includes('/home') || current.includes('/home')) {
            this.showMobileHeader = true;
          } else {
            this.showMobileHeader = false;
          }

          if (currentUrl.includes('/home') || current.includes('/home') || currentUrl.includes('/profiles') ||
            currentUrl.includes('/reward') || currentUrl.includes('/reward/explore') || currentUrl.includes('/reward/history') ||
            currentUrl.includes('/my-order') || currentUrl.includes('/my-order/active') || currentUrl.includes('/my-order/history')) {
            this.showMobileBottomNav = true;
          } else {
            this.showMobileBottomNav = false;
          }

          if (currentUrlPath1.includes('home') || current.includes('/home') || currentUrl.includes('/promotion-details-page')) {
            this.curRouter = 'home';
          } else if (currentUrlPath1.includes('store')) {
            this.curRouter = 'store';
          } else {
            this.curRouter = '';
          }

          if (currentUrl.includes('/store') || currentUrl.includes('/cart')) {
            this.isShowQrExpired = true;
          }

        } else {
          this.showMobileBottomNav = false;
        }

        let isBlockBack = this.sessionStorageService.getItem('isBlockBack');
        if (isBlockBack && !currentUrlPath1.includes('store')) {
          this.sessionStorageService.removeItem('isBlockBack');
        }
      }
    });
  }

  async ngOnInit() {
    this.enablePermissionDialogSub = this.addressService.enablePermissionDialog$.subscribe(() => {
      this.displayEnablePermissionDialog = true;
    });
    // await this.userchnService.checkUpdateDomainFlag();
    this.cartService.removePreviousFormatCart();

    this.loadingSubscription = this.loadingScreenService.loading$.pipe().subscribe((status: boolean) => {
      this.isFinishedLoading = !status;
    });

    this.sub = this.userService.get(StoreMode.Internal).subscribe((userData: any) => {
      if (!this.isUserLogin && userData) {
        this.channelSecService.removeAll();
      }

      this.isUserLogin = userData ? true : false;
    });

    this.storeService.triggeredAddressDialog$.subscribe(val => {
      if (val) {
        this.onClickLocation();
      }
      else {
        this.closeDialog();
      }
    });

    // check address
    this.popupAddressFormService.popupAddressForm.subscribe((result) => {
      if (result) {
        this.localSavedNewAddress = JSON.parse(localStorage.getItem('recent-address'));
        this.setAddressDialogVisibility(true);
        this.displayAddAddress = true;
        localStorage.removeItem('showAddressForm');
      }
    });

    this.qrTokenResponse = JSON.parse(this.sessionStorageService.getItem("qrTokenResponse"));
    if (!this.qrTokenResponse) {
      this.qrCartStore.update({ qrTokenResponse: null });
    }

    this.quitQrDineInSub = this.storeService.toQuitQrDineIn$.subscribe(toDisplay => {
      this.displayQuitQrDineMessage = toDisplay;
    });


    this.logOutSub = this.userService.isLoggedOut$.subscribe(toLogOut => {
      this.isLogOut = toLogOut;
    });

    this.qrDialog = this.rewardService.qrDialog.subscribe(val => {
      let isShow = val.isShow ?? false;
      if (!this.displayQrPopup) {
        this.qrPopupOverview = null;
      }
      this.barCodeValue = val.barCodeValue ?? null;
      this.qrCodeValue = val.qrCodeValue ?? null;
      if (this.barCodeValue && this.qrCodeValue) {
        this.qrPopupOverview = { barCodeValue: this.barCodeValue, qrCodeValue: this.qrCodeValue };
      }
      this.isRotate = !!this.barCodeValue && !this.qrCodeValue;

      if (isShow == true && (this.barCodeValue || this.qrCodeValue)) {
        this.displayQrPopup = true;
      }
    });



    this.channelSub = this.channelQuery.currentChannel$.subscribe(async (channel) => {
      this.channelOrderType = channel?.orderType;
      const orderTypeCount = await this.channelService.getOrderTypeCount(channel && channel?.data ? channel.data : null);

      // if channel order type count == 1 then get the only order type available
      if (orderTypeCount == 1) {
        this.channelOrderType = await this.channelService.getOrderTypeWhenOnlyOneType(channel.data);
      }

      this.channelSetting = channel?.data?.platformSets ? channel?.data?.platformSets : [];
      let foundSetting = this.channelSetting.find(setting => setting.setCode === SetCode.SHARETABLE)?.setValue;
      this.shareTable = foundSetting && foundSetting == '1' ? true : false;

      this.themeService.checkHrefToGetChannelTag();

      this.channelId = channel?.data.channelId ?? null;
    });

    this.qrScannerSub$ = this.qrScannerService.showPopupScanner$.subscribe((qrScannerData: any) => {
      this.displayScanner = qrScannerData.isShow;
      this.qrScannerData = qrScannerData;
    });

    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let userState = event.storageArea.getItem('eorder');

        if (userState) {
          let userStateObj = JSON.parse(userState);

          if (!userStateObj['user']?.active && this.userService.getCustomer()) {
            this.userService.logout();
          }
        }
      }
    }, false);

    // check and remove the guestOrder cache data
    this.removeExpiredGuestOrder();

    //curent selected address
    this.userQuery.selectedAddress$.subscribe(address => {
      if (address) {
        let pathSegments = this.channelService.getSegments();
        let curSubscriptionTag = pathSegments[0] ?? null;

        if (curSubscriptionTag && curSubscriptionTag === address.addressSubscriptionTag) {
          this.fulladdress = address.fullAddress;
        }
        else {
          this.userService.updateSelectedAddress(null);
        }
      }
    });

    this.qrQuerySub$ = this.qrCartQuery.qrWebLinkResponse$.subscribe(webLinkData => {
      if (webLinkData) {

        this.expiryTime = webLinkData?.expiryDate;
        this.serverTime = this.timeService.serverTime;
      }
    });

    let qrTokenResponse = this.qrCartService.get().qrTokenResponse;
    if (qrTokenResponse && qrTokenResponse.expiryDate) {
      this.expiryTime = qrTokenResponse.expiryDate;
      this.serverTime = this.timeService.serverTime;
    }

    this.submittingSub$ = this.qrCartService.submittingOrder$.subscribe(order => {
      this.submitingOrder = order;
    });
  }

  mobileOrderTypeChanged(selectedOrderType: string) {
    this.channelService.setCurrentOrderType(selectedOrderType);
    this.sessionStorageService.setItem("tempOrderType", JSON.stringify(selectedOrderType));
  }

  async mobileOrderTypeDoneAction() {
    this.displayOrderTypeAdressDialog = false;
    let orderType = this.channelService.getCurrentOrderType();
    this.staticQrService.saveChannelOrderType(orderType);
    this.analyticsService.selectDeliveryModeEvent(orderType);
    this.sessionStorageService.removeItem('tempOrderType')

    await this.channelService.getChannel({ orderType: orderType, channelTag: this.channelService.getChannelData().channelTag });
  }

  async onClickLocation() {
    this.addressService.setAddressDialogOpen(true);
    if (this.isUserLogin) {
      this.getCustomerAddress();
    } else {
      this.displayAddAddress = false;
      this.displayAddress = true;
      this.setAddressDialogVisibility(true);
    }
  }

  async onClickOrderTypeLocation() {
    this.displayOrderTypeAdressDialog = true;
  }

  async onSubmitAddAddress(data: any) {
    let resp = await this.userService.registerCustomerAddress(data);

    if (!(resp instanceof HttpErrorResponse) && this.isMobileView) {
      let toastData = {} as ToastData;
      toastData.successStatus = true;
      toastData.message = "desc.added.successfully";
      this.toastService.show(toastData);
    }
    await this.getCustomerAddress();
  }

  async onUpdateAddress(data: any) {
    await this.userService.updateCustomerAddress(data);
    this.updateAddressSuccess = true;
    await this.getCustomerAddress();
  }

  async deleteSelectedAddress(addressId: number) {
    let resp = await this.userService.deleteCustomerAddress(addressId, this.channelService.getChannelId());
    if (resp instanceof HttpErrorResponse) {
      let toastData = {} as ToastData;
      toastData.failStatus = true;
      toastData.message = "remove.failed";
      this.toastService.show(toastData);
    } else {
      let toastData = {} as ToastData;
      toastData.successStatus = true;
      toastData.message = "desc.removed.successfully";
      this.toastService.show(toastData);
      await this.getCustomerAddress();
    }
  }

  async getCustomerAddress() {
    this.addressService.setAddressDialogOpen(true);
    this.savedAddress = await this.userService.getCustomerAddress(this.channelService.getChannelId());
    this.displayAddAddress = false;
    this.displayAddress = true;
    this.setAddressDialogVisibility(true);
  }

  displayAddAddressForm(savedNewAddress: CommonAddressResponse) {
    this.editUserAddress = null;
    this.displayAddress = false;
    this.displayAddAddress = true;
    this.setAddressDialogVisibility(true);
    this.updateAddressSuccess = false;

    if (savedNewAddress) {
      this.localSavedNewAddress = savedNewAddress;
    }
  }

  onClickCloseDialog() {
    if (this.displayAddress) {
      this.storeService.openOutOfCoverage$.next(true);
    }
    this.closeDialog();
  }

  closeDialog() {
    if (this.displayAddress) {
      this.displayAddress = false;
      this.displayAddAddress = false;
      this.setAddressDialogVisibility(false);
      this.displayOrderTypeAdressDialog = false;
      if (this.router.url.includes('home')) {
        this.displayOrderTypeAdressDialog = true;
      }
    } else if (this.displayAddAddress) {
      this.displayAddress = true;
      this.displayAddAddress = false;
      this.setAddressDialogVisibility(true);
    }
  }

  editSelectedAddress(address: CXMCustomerAddressResponse) {
    this.displayAddAddress = true;
    this.displayAddress = false;
    this.setAddressDialogVisibility(true);
    this.editUserAddress = address;
  }

  setAddressDialogVisibility(isVisible: boolean): void {
    this.displayAddressDialog = isVisible;
    this.addressService.setAddressDialogOpen(isVisible);
  }

  //#region quit qr dine in
  closeQuitQrDialog() {
    this.displayQuitQrDineMessage = false;
    this.storeService.closeQuitQrDialog();

    if (this.sessionStorageService.getItem('reopenAlert')) {
      this.storeService.reopenAlertDialog$.next(true)
    }
  }

  quitQrDineInMode() {
    let channelData = this.channelService.getChannelData();
    this.closeQuitQrDialog();

    this.storageService.resetQrExpiryTime();
    this.timeService.removeIdleTime();
    this.qrCartService.quitQrDineInCheck();
    this.staticQrService.remove();

    if (this.isLogOut) {
      this.userService.logoutInit();
      this.channelService.getChannel();
    }
    else {
      this.routingService.navigate(PageName.HomePage, channelData);
    }

    if (this.sessionStorageService.getItem('reopenAlert')) {
      this.sessionStorageService.removeItem('reopenAlert')
    }
  }
  //#endregion


  ngOnDestroy() {
    this.enablePermissionDialogSub?.unsubscribe();
    this.loadingSubscription?.unsubscribe();
    this.quitQrDineInSub?.unsubscribe();
    this.logOutSub?.unsubscribe();
    this.qrDialog?.unsubscribe();
    this.sub?.unsubscribe();
    this.channelSub?.unsubscribe();
    this.quitQueueSub$?.unsubscribe();
    this.qrQuerySub$?.unsubscribe();
    this.submittingSub$?.unsubscribe();
  }

  removeExpiredGuestOrder() {
    this.guestOrderService.getReferences();
  }

  //#region queue quit logic

  async quitQueueMode() {
    let channelData = this.channelService.getChannelData();
    let switchChannelData = this.channelService.getSwitchChannelData();

    this.queueService.removeQueueData();
    this.queueService.removeShowBackIcon();
    this.queueService.removeActivityRsvToken();

    if (this.isLogOut) {
      this.userService.logoutInit();
      this.channelService.getChannel();
    }
    else {
      if (channelData) {
        this.routingService.navigate(PageName.HomePage, channelData);
      }
      else if (switchChannelData) {
        this.routingService.navigateHomeCheck(switchChannelData);
      }
      else {
        switchChannelData = await this.channelService.switchChannelVerify(false);
        this.channelService.setSwitchChannelData(switchChannelData);
        this.routingService.navigateHomeCheck(switchChannelData);
      }
    }
  }

  onShowExpiryDate(showExpiryDate: boolean) {
    this.isDisplayQRExpired = showExpiryDate;
    this.qrCartService.displayQrExpiryDate$.next(true);
  }

  onQrPopupBack(): void {
    if (this.qrPopupOverview && !(this.barCodeValue && this.qrCodeValue)) {
      this.barCodeValue = this.qrPopupOverview.barCodeValue;
      this.qrCodeValue = this.qrPopupOverview.qrCodeValue;
      this.isRotate = false;
      return;
    }

    this.displayQrPopup = false;
    this.qrPopupOverview = null;
    this.isRotate = false;
  }

  onTimeup() {
    let qrTokenResponse = this.qrCartService.get()?.qrTokenResponse;
    if (qrTokenResponse && !this.submitingOrder) {
      this.weblinkService.reValidateWebLinkToken(qrTokenResponse.tokenId);
    }
    this.isDisplayQRExpired = false;
    this.qrCartService.displayQrExpiryDate$.next(false);
  }

  //#endregion

  updateMetaTag(url: any) {
    let href = this.platformLocation.href;
    let path = href.split(/https?:\/\//).map(part => part.split('.'))[1][0];

    if (path.includes(environment.hostName) || path.includes('localhost')) {
      this.seoService.manageMetaTag(url);
    }
    else {
      this.seoService.manageMetaTag(url, path);
    }
  }
}
